"use strict";

/* ================= data ================= */
const MAKES = {
  "BMW":["M2 (G87)","M3 (G80)","M4 (G82)"],
  "Chevrolet":["Corvette C8"],
  "Subaru":["WRX VA","WRX VB"],
  "Toyota":["GR Supra"],
  "Acura":["TLX","Integra"],
  "Other":["My vehicle isn't listed"]
};
const MATS = {
  carbonG:{name:"Gloss carbon", price:0, img:"superauto-mat2-carbong.webp", colors:[["Gloss twill","#24272C"],["Gloss red foil","#3A2426"],["Gloss gold foil","#5A4727"],["Purple silk","#3D2A56"]]},
  carbonM:{name:"Matte carbon", price:0, img:"superauto-mat2-carbonm.webp", colors:[["Matte twill","#2F3237"],["Matte black","#181A1E"]]},
  dryCarbonM:{name:"Matte dry carbon", price:50, img:"superauto-mat2-drycarbon.webp", colors:[["Matte dry carbon","#202328"]]},
  dryCarbonG:{name:"Gloss dry carbon", price:50, img:"superauto-mat2-drycarbong.webp", colors:[["Gloss dry carbon","#232830"]]},
  forgedG:{name:"Gloss forged carbon", price:100, img:"superauto-mat2-forgedg.webp", colors:[["Regular","#343842"],["With red flakes","#8F2A26"],["With blue flakes","#2C55B0"],["With orange flakes","#C4761F"],["With purple flakes","#6A3FB5"],["With green flakes","#3E8C42"],["With gold flakes","#C9A535"],["With silver flakes","#C9CCD1"]]},
  forgedM:{name:"Matte forged carbon", price:100, img:"superauto-mat2-forgedm.webp", colors:[]},
  smooth:{name:"Smooth leather", price:0, img:"superauto-mat2-smooth.webp", gripImg:"superauto-grip-smooth.webp", colors:[["Black","#232326"],["Red","#8E262B"],["Yellow","#C9A535"],["Dark blue","#1B2A4A"],["Blue","#2F55A4"],["Light blue","#7FA8D9"],["Purple","#5B3E8E"],["Grey","#8A8D93"],["Dark grey","#4A4D52"],["Light grey","#C4C6CA"],["Green","#2F6B3F"]]},
  perf:{name:"Perforated leather", price:0, gripImg:"superauto-grip-perf.webp", colors:[["Black","#232326"],["Red","#8E262B"],["Yellow","#C9A535"],["Dark blue","#1B2A4A"],["Blue","#2F55A4"],["Light blue","#7FA8D9"],["Purple","#5B3E8E"],["Grey","#8A8D93"],["Dark grey","#4A4D52"],["Light grey","#C4C6CA"],["Green","#2F6B3F"]]},
  semiPerf:{name:"Semi-perforated leather", price:0, colors:[["Black","#202124"],["Gray","#55585E"]]},
  alcantara:{name:"Alcantara", price:70, gripImg:"superauto-grip-alcantara.webp", colors:[["Black","#232326"],["Red","#8E262B"],["Yellow","#C9A535"],["Dark blue","#1B2A4A"],["Blue","#2F55A4"],["Light blue","#7FA8D9"],["Purple","#5B3E8E"],["Grey","#8A8D93"],["Dark grey","#4A4D52"],["Light grey","#C4C6CA"],["Green","#2F6B3F"]]}
};
const STITCH = [
  ["Yellow","#D9A82E","superauto-stitch-yellow.webp"],
  ["Red","#C8352E","superauto-stitch-red.webp"],
  ["Blue","#3563A8","superauto-stitch-blue.webp"],
  ["BMW Tricolor","linear-gradient(90deg,#2E7DDE 0 33%,#273E87 33% 66%,#C8352E 66%)","superauto-stitch-bmw.webp"],
  ["Purple","#7B4BC7","superauto-stitch-purple.webp"],
  ["White","#EDEBE6","superauto-stitch-white.webp"],
  ["Neon yellow","#D7FF37","superauto-stitch-neonyellow.webp"],
  ["Black","#222327","superauto-stitch-black.webp"],
  ["Gray","#8A8D93","superauto-stitch-gray.webp"],
  ["Orange","#D06A2C","superauto-stitch-orange.webp"]
];
const SCREWS = [["Black","#26282C"],["Silver","#C2C6CC"],["Red","#B03028"],["Gold","#C79A3B"]];
const STRIPES = [
  ["Black","#222327","superauto-stripe2-black.webp"],
  ["Blue","#3563A8","superauto-stripe2-blue.webp"],
  ["BMW Tricolor","linear-gradient(90deg,#2E7DDE 0 33%,#273E87 33% 66%,#C8352E 66%)","superauto-stripe2-bmw.webp"],
  ["Gray","#8A8D93","superauto-stripe2-gray.webp"],
  ["Neon yellow","#D7FF37","superauto-stripe2-neonyellow.webp"],
  ["Orange","#D06A2C","superauto-stripe2-orange.webp"],
  ["Purple","#7B4BC7","superauto-stripe2-purple.webp"],
  ["Red","#C8352E","superauto-stripe2-red.webp"],
  ["White","#EDEBE6","superauto-stripe2-white.webp"],
  ["Yellow","#D9A82E","superauto-stripe2-yellow.webp"]
];
const STYLES = [["flatbottom","Flat bottom","Round top / flat bottom",0,"superauto-style-flatbottom.webp"],["competition","Flat top & bottom","Squared-off motorsport profile",0,"superauto-style-competition.webp"],["pilot","Pilot shape","Aviation yoke silhouette",0,"superauto-style-pilot.webp"],["allround","All round","Fully circular rim",0,"superauto-style-allround.webp"]];
const THICK = [["oem","OEM thickness","",0],["thick","Extra thickness","11-12.5 mm rim",0]];
const LEDKIT = [["none","No LED display","",0],["led24","24 lights","Shift-light strip at 12 o'clock",150,"superauto-led-led24-v2.webp"],["led50","50 lights","Higher-density strip, smoother sweep",200,"superauto-led-led50-v2.webp"]];
const TRANS = [["auto","Automatic","Paddle-ready"],["manual","Manual","No paddles"]];
const OEMHEAT = [["yes","Yes, factory heated",""],["no","No / not sure",""]];
// the toggle owns on/off; every finish bills through the same $100 upgrade
const PADDLES = [
  ["none","No paddles","",0],
  ["carbonG","Gloss carbon","",0,"superauto-paddle-carbong.webp",null],
  ["carbonM","Matte carbon","",0,"superauto-paddle-carbonm.webp",null],
  ["dryCarbonG","Gloss dry carbon","",100,"superauto-paddle-drycarbong.webp","Paddle Shifters - Dry Carbon"],
  ["dryCarbonM","Matte dry carbon","",100,"superauto-paddle-drycarbonm.webp","Paddle Shifters - Dry Carbon"],
  ["forgedG","Gloss forged carbon","",100,"superauto-paddle-forgedg.webp","Paddle Shifters - Forged Carbon"],
  ["forgedM","Matte forged carbon","",100,"superauto-paddle-forgedm.webp","Paddle Shifters - Forged Carbon"]
];
// exact variant title on the upgrade product (note: spelled "megnent" there)
const PADDLE_MAGNET=["Paddle Shifters - megnent",20];
const HEAT = [["none","No heating","",0],["yes","Add / retain heating","Requires compatible wheel and wiring",100]];
// same option set and order as the rim halves, with center-trim photos
const TRIM_B = [
  ["Gloss carbon",0,"superauto-trim-carbong.webp"],
  ["Matte carbon",0,"superauto-trim-carbonm.webp"],
  ["Gloss dry carbon",0,"superauto-trim-drycarbong.webp"],
  ["Matte dry carbon",0,"superauto-trim-drycarbonm.webp"],
  ["Gloss forged carbon",0,"superauto-trim-forgedg.webp","forgedG"],
  ["Matte forged carbon",0,"superauto-trim-forgedm.webp","forgedM"],
  ["Smooth leather",0,"superauto-trim-smooth.webp","smooth"]
];
const TRIM_E = [["Carbon",0],["Forged foil",null],["Keep OEM button surround",0]];
// same finishes and order as the rim halves / center trim; the yes-no toggle
// owns on/off, and the inlay upgrade itself is a flat $70 whichever finish
const THUMB_INLAYS = [
  ["carbonG","Gloss carbon","",70,"superauto-inlay-carbong.webp"],
  ["carbonM","Matte carbon","",70,"superauto-inlay-carbonm.webp"],
  ["dryCarbonG","Gloss dry carbon","",70,"superauto-inlay-drycarbong.webp"],
  ["dryCarbonM","Matte dry carbon","",70,"superauto-inlay-drycarbonm.webp"],
  ["forgedG","Gloss forged carbon","",70,"superauto-inlay-forgedg.webp","forgedG"],
  ["forgedM","Matte forged carbon","",70,"superauto-inlay-forgedm.webp","forgedM"],
  ["smooth","Smooth leather","",70,"superauto-inlay-smooth.webp","smooth"]
];

/* ================= state ================= */
const S = {
  year:"", make:"", model:"", trans:"", oemheat:"",
  style:"", thick:"", grooves:false,
  mainTop:"", mainTopColor:0, same:true, mainBot:"", mainBotColor:0,
  grip:"", gripColor:0, trimon:false, bottomTrim:"", bottomTrimColor:0, emblemTrim:"Carbon",
  inlays:false, thumbinlay:"", inlayflake:0, stitch:null, screws:0, stripe:false, stripecolor:0,
  paddleson:false, paddles:"none", magnetic:false, heaton:false, heat:"none", ledon:false, ledkit:"none", collision:false,
  halfwrap:false, airbagCover:false, airbagMat:"smooth", airbagColor:0, notes:"",
  files:{}
};
const BASE_MIN = 399;
const BASE_MAX = 399;
const root = document.querySelector("[data-superauto-customizer]");
const $$ = s => root ? root.querySelector("#"+s) : document.getElementById(s);
const ASSET_BASE = document.currentScript && document.currentScript.src ? document.currentScript.src.replace(/superauto-wheel-customizer\.js.*$/,"") : "";
const assetUrl = name => ASSET_BASE + name;
const money = n => "$" + n.toLocaleString();
const priceText = n => n ? "+$" + n : "";
const lineValue = l => l[2] || money(l[1]);

/* ================= pricing ================= */
const basePrice = () => /c8/i.test(S.model||"") ? 499 : 399; // Corvette C8 base is $499

function lines(){
  const L=[["Base price",basePrice()]];
  const isForged=k=>k==="forgedG"||k==="forgedM";
  const isDry=k=>k==="dryCarbonM"||k==="dryCarbonG";
  if(isForged(S.mainTop)||(!S.same&&isForged(S.mainBot))) L.push(["Rim: Forged carbon",100]);
  if(isDry(S.mainTop)||(!S.same&&isDry(S.mainBot))) L.push(["Rim: Dry carbon",50]);
  if(S.halfwrap) L.push(["Half wrap",100]);
  const g=MATS[S.grip]; if(g && g.price) L.push(["Grip: "+g.name,g.price]);
  const ti=S.inlays?THUMB_INLAYS.find(t=>t[0]===S.thumbinlay):null; if(ti) L.push(["Thumb-grip inlays: "+ti[1],70]);
  const pd=PADDLES.find(p=>p[0]===S.paddles);
  if(pd && pd[3]) L.push(["Paddle shifters: "+pd[1],pd[3]]);
  if(S.paddleson && S.magnetic) L.push(["Magnetic paddles",PADDLE_MAGNET[1]]);
  const ht=HEAT.find(h=>h[0]===S.heat); if(ht && ht[3]) L.push([ht[1],ht[3]]);
  { const lk=LEDKIT.find(x=>x[0]===S.ledkit); if(lk && lk[3]) L.push(["LED RPM Display — "+lk[1],lk[3]]); }
  if(S.collision) L.push(["BMW M1/M2 buttons / module",100]);
  if(S.airbagCover) L.push(["Airbag cover",120]);
  return L;
}
function total(){ return lines().reduce((a,l)=>a+(Number(l[1])||0),0); }
function lead(){
  return "3-7 weeks";
}

/* ================= wheel SVG ================= */
function wheelSVG(hl){
  const hexOf=(k,ck)=>{const m=MATS[S[k]]; const c=m&&m.colors[S[ck]]; return c?c[1]:"#383B42";};
  const mt=hexOf("mainTop","mainTopColor");
  const mb=S.same?mt:hexOf("mainBot","mainBotColor");
  const gc=hexOf("grip","gripColor");
  const sc=(STITCH[S.stitch]||STITCH[7])[1];
  const scr=SCREWS[S.screws][1];
  const stc=STRIPES[S.stripecolor][1];
  const R=92,W=24;
  const pt=a=>[R*Math.cos(a*Math.PI/180),R*Math.sin(a*Math.PI/180)];
  const arcPath=(a1,a2,r)=>{
    r=r||R;
    const x1=r*Math.cos(a1*Math.PI/180),y1=r*Math.sin(a1*Math.PI/180),
          x2=r*Math.cos(a2*Math.PI/180),y2=r*Math.sin(a2*Math.PI/180),large=(a2-a1)>180?1:0;
    return `M ${x1.toFixed(1)} ${y1.toFixed(1)} A ${r} ${r} 0 ${large} 1 ${x2.toFixed(1)} ${y2.toFixed(1)}`;
  };
  const chordPath=(a1,a2)=>{
    const [x1,y1]=pt(a1),[x2,y2]=pt(a2);
    return `M ${x1.toFixed(1)} ${y1.toFixed(1)} L ${x2.toFixed(1)} ${y2.toFixed(1)}`;
  };
  const flatB=(S.style==="flatbottom"||S.style==="competition"||S.style==="pilot");
  const flatT=(S.style==="flattop"||S.style==="competition"||S.style==="pilot");
  const RIMPARTS=["mainTop","mainBot","grip"];
  const isLit=p=>{
    if(!hl) return null;
    if(hl==="shape"||hl==="heat") return RIMPARTS.includes(p);
    if(hl==="mainTop"&&S.same) return p==="mainTop"||p==="mainBot";
    return p===hl;
  };
  const op=p=>{const m=isLit(p);return m===null?1:(m?1:.22);};
  const GLOW = hl==="heat" ? "#E0763A" : "#F5F2EA";
  const glowFor=(d,w)=>`<path d="${d}" fill="none" stroke="${GLOW}" stroke-width="${w+14}" stroke-linecap="round" class="pul"/>`;
  const ghost=(d,w)=>`<path d="${d}" fill="none" stroke="#F5F2EA" stroke-width="${w}" stroke-linecap="round" stroke-dasharray="6 6" opacity=".55"/>`;
  const texFor=k=>(k.startsWith("carbon")||k.startsWith("dryCarbon")||k.startsWith("forged"))?"url(#cfp)":((k==="perf"||k==="semiPerf")?"url(#perfp)":null);

  const pieces=[];
  if(flatT) pieces.push({d:arcPath(182,238),c:mt,p:"mainTop",m:S.mainTop},{d:chordPath(238,302),c:mt,p:"mainTop",m:S.mainTop},{d:arcPath(302,358),c:mt,p:"mainTop",m:S.mainTop});
  else pieces.push({d:arcPath(182,358),c:mt,p:"mainTop",m:S.mainTop});
  if(flatB) pieces.push({d:arcPath(2,58),c:mb,p:"mainBot",m:S.same?S.mainTop:S.mainBot},{d:chordPath(58,122),c:mb,p:"mainBot",m:S.same?S.mainTop:S.mainBot},{d:arcPath(122,178),c:mb,p:"mainBot",m:S.same?S.mainTop:S.mainBot});
  else pieces.push({d:arcPath(2,178),c:mb,p:"mainBot",m:S.same?S.mainTop:S.mainBot});
  pieces.push({d:arcPath(-28,28),c:gc,w:W+2,p:"grip",m:S.grip},{d:arcPath(152,208),c:gc,w:W+2,p:"grip",m:S.grip});

  let s=`<defs>
    <pattern id="cfp" width="7" height="7" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="7" height="7" fill="rgba(255,255,255,0)"/><rect width="3.5" height="3.5" fill="rgba(255,255,255,.09)"/><rect x="3.5" y="3.5" width="3.5" height="3.5" fill="rgba(255,255,255,.09)"/></pattern>
    <pattern id="perfp" width="6.5" height="6.5" patternUnits="userSpaceOnUse"><circle cx="3.2" cy="3.2" r="1.05" fill="rgba(0,0,0,.55)"/></pattern>
    <radialGradient id="hubg" cx="38%" cy="30%" r="85%"><stop offset="0%" stop-color="#4B4F58"/><stop offset="100%" stop-color="#24262B"/></radialGradient>
  </defs>`;
  s+=`<ellipse cy="112" rx="84" ry="9" fill="#000" opacity=".4"/>`;
  pieces.forEach(p=>{ if(isLit(p.p)) s+=glowFor(p.d,p.w||W); });
  s+=pieces.map(p=>{
    let out=`<path d="${p.d}" fill="none" stroke="${p.c}" stroke-width="${p.w||W}" stroke-linecap="round" opacity="${op(p.p)}"/>`;
    const tex=texFor(p.m);
    if(tex) out+=`<path d="${p.d}" fill="none" stroke="${tex}" stroke-width="${p.w||W}" stroke-linecap="round" opacity="${op(p.p)}"/>`;
    return out;
  }).join("");
  s+=`<path d="${arcPath(195,255)}" fill="none" stroke="#FFFFFF" stroke-width="${W-12}" stroke-linecap="round" opacity="${.10*op("mainTop")}"/>`;
  s+=`<path d="${arcPath(20,60)}" fill="none" stroke="#000000" stroke-width="${W-10}" stroke-linecap="round" opacity="${.16*op("mainBot")}"/>`;

  const stW = hl==="stitch" ? 3 : 1.6;
  s+=pieces.map(p=>`<path d="${p.d}" fill="none" stroke="${sc}" stroke-width="${stW}" stroke-dasharray="5 6" opacity="${.9*op("stitch")}"/>`).join("");

  const inlayD=[arcPath(-26,-6),arcPath(186,206)];
  if(S.inlays && S.thumbinlay && S.thumbinlay!=="none"){
    if(isLit("thumbinlay")) inlayD.forEach(d=>s+=glowFor(d,8));
    inlayD.forEach(d=>s+=`<path d="${d}" fill="none" stroke="#101114" stroke-width="8" stroke-linecap="round" opacity="${op("thumbinlay")}"/>`);
  } else if(hl==="thumbinlay") inlayD.forEach(d=>s+=ghost(d,8));

  const stripeD = flatT?chordPath(262,278):arcPath(262,278);
  if(S.stripe){
    if(isLit("stripe")) s+=glowFor(stripeD,W+3);
    s+=`<path d="${stripeD}" fill="none" stroke="${stc}" stroke-width="${W+3}" stroke-linecap="butt" opacity="${op("stripe")}"/>`;
  } else if(hl==="stripe") s+=ghost(stripeD,W+3);

  const ledD = flatT ? `M -30 -58 L 30 -58` : arcPath(255,285,R-22);
  if(S.ledkit!=="none"){
    if(isLit("led")) s+=glowFor(ledD,5);
    s+=`<path d="${ledD}" fill="none" stroke="#2ECC71" stroke-width="5" stroke-linecap="round" opacity="${op("led")}"/>`;
  } else if(hl==="led") s+=ghost(ledD,5);

  const spokeOp=op("spokes");
  s+=`<g opacity="${spokeOp}"><rect x="${-R+10}" y="-9" width="${R-38}" height="18" rx="6" fill="#2B2E34"/>`;
  s+=`<rect x="28" y="-9" width="${R-38}" height="18" rx="6" fill="#2B2E34"/>`;
  s+=`<rect x="-9" y="26" width="18" height="${R-40}" rx="6" fill="#2B2E34"/></g>`;

  if(S.paddles!=="none"){
    let pads=`<rect x="-88" y="-34" width="26" height="58" rx="10" fill="#0B0C0E" opacity="${op("paddles")}"/><rect x="62" y="-34" width="26" height="58" rx="10" fill="#0B0C0E" opacity="${op("paddles")}"/>`;
    if(isLit("paddles")) pads=`<rect x="-88" y="-34" width="26" height="58" rx="10" fill="none" stroke="${GLOW}" stroke-width="10" class="pul"/><rect x="62" y="-34" width="26" height="58" rx="10" fill="none" stroke="${GLOW}" stroke-width="10" class="pul"/>`+pads;
    s=pads+s;
  } else if(hl==="paddles"){
    s=`<rect x="-88" y="-34" width="26" height="58" rx="10" fill="none" stroke="#F5F2EA" stroke-width="2" stroke-dasharray="6 6" opacity=".55"/><rect x="62" y="-34" width="26" height="58" rx="10" fill="none" stroke="#F5F2EA" stroke-width="2" stroke-dasharray="6 6" opacity=".55"/>`+s;
  }

  const etColor = S.emblemTrim==="Carbon fiber" ? "#33363C" : (S.emblemTrim==="Brushed aluminum"?"#9CA1A8":"#131518");
  if(isLit("trim")) s+=`<circle r="34" fill="none" stroke="${GLOW}" stroke-width="14" class="pul"/>`;
  if(isLit("hub")) s+=`<circle r="26" fill="none" stroke="${GLOW}" stroke-width="12" class="pul"/>`;
  s+=`<circle r="34" fill="url(#hubg)" opacity="${Math.max(op("trim"),op("hub"))}"/><circle r="34" fill="none" stroke="${etColor}" stroke-width="5" opacity="${op("trim")}"/>`;
  if(S.emblemTrim==="Carbon fiber") s+=`<circle r="34" fill="none" stroke="url(#cfp)" stroke-width="5" opacity="${op("trim")}"/>`;
  s+=`<circle r="24" fill="#1E2126" opacity="${op("hub")}"/><circle r="24" fill="none" stroke="rgba(255,255,255,.08)" stroke-width="1.5" opacity="${op("hub")}"/>`;
  s+=`<text y="5" text-anchor="middle" font-family="var(--sans)" font-size="11" font-weight="800" fill="#C9C7C1" letter-spacing=".08em" opacity="${op("hub")}">SA</text>`;

  if(isLit("screws")) s+=`<circle cx="-46" cy="0" r="10" fill="${GLOW}" class="pul"/><circle cx="46" cy="0" r="10" fill="${GLOW}" class="pul"/><circle cx="0" cy="48" r="10" fill="${GLOW}" class="pul"/>`;
  s+=`<circle cx="-46" cy="0" r="4.5" fill="${scr}" opacity="${op("screws")}"/><circle cx="46" cy="0" r="4.5" fill="${scr}" opacity="${op("screws")}"/><circle cx="0" cy="48" r="4.5" fill="${scr}" opacity="${op("screws")}"/>`;
  return s;
}
let curHL=null;
const PARTNAMES={shape:"Editing: wheel shape",mainTop:"Editing: top half",mainBot:"Editing: bottom half",grip:"Editing: grip",trim:"Editing: trim pieces",thumbinlay:"Editing: thumb inlay",stitch:"Editing: side stitching",screws:"Editing: screws",stripe:"Editing: center stripe",paddles:"Editing: paddle shifters",heat:"Editing: heating",led:"Editing: LED display",hub:"Editing: center hub"};
const PREVIEW_PHOTOS={
  oem:"superauto-steering-wheel.png",
  black:"nexanovo-wheel-frame-29.png",
  red:"nexanovo-wheel-frame-30.png",
  yellow:"nexanovo-wheel-frame-32.png"
};
function solidColor(value){
  if(!value) return "#D6473A";
  return value.startsWith("linear-gradient") ? "#2E7DDE" : value;
}
function resolvePreviewPhoto(){
  const nameOf=(k,ck)=>{const c=MATS[S[k]].colors[S[ck]]; return (c?c[0]:MATS[S[k]].name).toLowerCase();};
  const topColor=nameOf("mainTop","mainTopColor");
  const gripColor=nameOf("grip","gripColor");
  const stripe=STRIPES[S.stripecolor][0].toLowerCase();
  if(gripColor.includes("yellow") || (S.stripe && stripe.includes("yellow"))) return PREVIEW_PHOTOS.yellow;
  if(gripColor.includes("red") || topColor.includes("red") || (S.stripe && stripe.includes("red"))) return PREVIEW_PHOTOS.red;
  return PREVIEW_PHOTOS.black;
}
function updatePhotoPreview(){
  const stage=$$("photoPreview");
  const img=$$("previewWheelPhoto");
  const stripe=$$("previewStripe");
  if(stage) stage.dataset.activePart=curHL||"";
  if(img){
    const next=assetUrl(resolvePreviewPhoto());
    if(img.getAttribute("src")!==next) img.src=next;
  }
  if(stripe){
    stripe.style.setProperty("--stripe-color",solidColor(STRIPES[S.stripecolor][1]));
    stripe.style.setProperty("--stripe-opacity",S.stripe ? ".95" : ".22");
  }
}
function setHL(p){
  if(p===curHL) return;
  curHL=p;
  const el=$$("prevWheel"); if(el) el.innerHTML=wheelSVG(curHL);
  const cap=$$("prevcap-txt"); if(cap) cap.textContent = p ? (PARTNAMES[p]||"") : "";
  updatePhotoPreview();
}
function renderWheels(){
  const plain=wheelSVG(null);
  const ck=$$("ckWheel"); if(ck) ck.innerHTML=plain;
  const prev=$$("prevWheel"); if(prev) prev.innerHTML=wheelSVG(curHL);
  updatePhotoPreview();
}

/* ================= builders ================= */
function buildCards(id, items, key, fmt, adv){
  const el=$$(id); el.innerHTML="";
  items.forEach(it=>{
    const b=document.createElement("button");
    b.className="optcard"+(S[key]===it[0]?" sel":"");
    b.innerHTML=fmt(it);
    b.onclick=()=>{S[key]=it[0]; buildCards(id,items,key,fmt,adv); if(typeof syncTrimUI==="function") syncTrimUI(); if(typeof syncAirbagUI==="function") syncAirbagUI(); afterChange(key);
      const go_=typeof adv==="function"?adv(it):(adv!==false);
      if(go_) advanceFrom(id);};
    el.appendChild(b);
  });
}
// gentle nudge to whatever the customer has to answer next: the following
// visible group in the same step, if it is still unanswered
function hasAnswer(k){ return !(S[k]===""||S[k]==null); }
function advanceFrom(id){
  const el=$$(id); if(!el) return;
  const panel=el.closest(".cstep"); if(!panel) return;
  const groups=[...panel.querySelectorAll("fieldset")].filter(f=>!f.hidden && f.offsetParent!==null);
  const here=el.closest("fieldset");
  const next=groups[groups.indexOf(here)+1]||null;
  const target=next||panel.querySelector(".stepnav");
  if(!target) return;
  if(typeof qFocusPin!=="undefined"){ qFocusPin=next||here; qPinGuard=Date.now()+900;
    QDBG("advance from "+id+" pin="+((qFocusPin.querySelector("legend")||qFocusPin.querySelector(".t")||{}).textContent||"?").slice(0,18));
    if(typeof updateQFocus==="function") updateQFocus(); }
  requestAnimationFrame(()=>{
    // scroll only when the next question is not comfortably in view, and land
    // its title ~15% from the top of the pane instead of flush against it
    const main=root.querySelector(".config-main");
    if(!main){ try{ target.scrollIntoView({behavior:"smooth",block:next?"start":"end"}); }catch(e){} return; }
    const mr=main.getBoundingClientRect(), tr=target.getBoundingClientRect();
    const comfortTop=mr.top+Math.min(90,mr.height*0.15);
    let delta=0;
    if(!next){
      if(tr.bottom>mr.bottom-12) delta=tr.bottom-(mr.bottom-12);
    } else if(tr.top<mr.top+8 || tr.top>mr.top+mr.height*0.5){
      delta=tr.top-comfortTop;
    }
    if(Math.abs(delta)>4) main.scrollBy({top:delta,behavior:"smooth"});
  });
}
function pixelWheelColorize(val){
  const host=$$("pixelWheel"); if(!host) return;
  host.classList.add("colored");
  const c=solidColor(val);
  // replace cells rather than restyle: browsers pin the originals' painted background
  host.querySelectorAll(".acc").forEach(px=>{
    const n=px.cloneNode(false);
    n.style.background=c;
    px.replaceWith(n);
  });
}
// photo cards for the colour pickers that have per-option photos
function buildPhotoCards(id, items, key){
  const el=$$(id); if(!el) return; el.innerHTML="";
  items.forEach((c,i)=>{
    const b=document.createElement("button");
    b.type="button";
    b.className="optcard"+(S[key]===i?" sel":"");
    b.innerHTML=`<img class="matimg" src="${assetUrl(c[2])}" alt="" loading="lazy"><div class="t">${c[0]}</div>`;
    b.onclick=()=>{S[key]=i; buildPhotoCards(id,items,key); refresh(); advanceFrom(id);};
    el.appendChild(b);
  });
  const n=$$("swn-"+id.slice(3)); if(n) n.hidden=true;
}
function buildStripeCards(){ buildPhotoCards("sw-stripecolor",STRIPES,"stripecolor"); }
function buildSwatches(id, items, key){
  const el=$$(id); if(!el) return; el.innerHTML="";
  items.forEach((c,i)=>{
    const b=document.createElement("button");
    b.className="sw"+(S[key]===i?" sel":"");
    b.style.background=c[1]; b.title=c[0]; b.setAttribute("aria-label",c[0]);
    b.onclick=()=>{S[key]=i; buildSwatches(id,items,key); const n=$$("swn-"+id.slice(3)); if(n) n.textContent=c[0]; pixelWheelColorize(c[1]); refresh(); advanceFrom(id);};
    el.appendChild(b);
  });
  const n=$$("swn-"+id.slice(3)); if(n) n.textContent=items[S[key]] ? items[S[key]][0] : "";
  const single=items.length<2;
  el.hidden=single; if(n) n.hidden=single;
}
function buildSelect(id, items, key){
  const el=$$(id); el.innerHTML="";
  items.forEach(it=>{
    const o=document.createElement("option");
    const label = it[1] ? "  (+$"+it[1]+")" : "";
    o.value=it[0]; o.textContent=it[0]+label;
    if(S[key]===it[0]) o.selected=true;
    el.appendChild(o);
  });
}
function inlayColors(){
  const t=THUMB_INLAYS.find(x=>x[0]===S.thumbinlay);
  return (t && t[5] && MATS[t[5]]) ? MATS[t[5]].colors : [];
}
function inlayLabel(){
  if(!S.inlays) return "No";
  const t=THUMB_INLAYS.find(x=>x[0]===S.thumbinlay);
  if(!t) return "No";
  const c=inlayColors()[S.inlayflake];
  return c ? t[1]+" — "+c[0] : t[1];
}
function trimColors(){
  const t=TRIM_B.find(x=>x[0]===S.bottomTrim);
  return (t && t[3] && MATS[t[3]]) ? MATS[t[3]].colors : [];
}
function trimLabel(){
  if(!S.trimon) return "No";
  const c=trimColors()[S.bottomTrimColor];
  return c ? S.bottomTrim+" — "+c[0] : S.bottomTrim;
}
function syncTrimUI(){
  const ic=inlayColors();
  if(S.inlayflake>=ic.length) S.inlayflake=0;
  const fl=$$("wrap-inlayflake"); if(fl) fl.hidden = !(S.inlays && ic.length>1);
  buildSwatches("sw-inlayflake",ic,"inlayflake");
  // switching trim can leave the colour index past the new palette's end
  const tc=S.trimon?trimColors():[];
  if(S.bottomTrimColor>=tc.length) S.bottomTrimColor=0;
  buildSwatches("sw-bottomTrim",tc,"bottomTrimColor");
}
function setSel(key,val){ S[key]=val; syncTrimUI(); refresh(); }
const YN_ADVANCE={same:v=>v,halfwrap:()=>true,stripe:v=>!v,trimon:v=>!v,inlays:v=>!v,airbagCover:v=>!v,paddleson:v=>!v,magnetic:()=>true,heaton:()=>true,ledon:v=>!v};
function setYN(key,val,el){
  S[key]=val;
  [...el.parentElement.children].forEach(b=>b.classList.toggle("sel",b===el));
  if(key==="same") $$("wrap-mainBot").hidden=val;
  if(key==="stripe") $$("wrap-stripecolor").hidden=!val;
  if(key==="airbagMat") syncAirbagUI();
  if(key==="inlays"){ $$("wrap-inlayopts").hidden=!val; syncTrimUI(); }
  if(key==="trimon"){ $$("wrap-trimopts").hidden=!val; syncTrimUI(); }
  if(key==="airbagCover") syncAirbagUI();
  if(key==="paddleson"){ $$("wrap-paddleopts").hidden=!val; S.paddles=val?(S.paddles==="none"?"carbonG":S.paddles):"none"; if(!val){ S.magnetic=false; setYNUI("f-magnetic",false); } buildPaddleCards(); gatePaddles(); }
  if(key==="heaton"){ S.heat=val?"yes":"none"; }
  if(key==="ledon"){ $$("wrap-ledopts").hidden=!val; S.ledkit=val?(S.ledkit==="none"?"led24":S.ledkit):"none"; buildLedCards(); }
  refresh();
  const advFn=YN_ADVANCE[key];
  if(advFn && advFn(val)){ const t=el.closest(".toggle"); if(t && t.id) advanceFrom(t.id); }
}
function matCards(id,key,colorKey){
  const rimKeys=["carbonG","carbonM","dryCarbonG","dryCarbonM","forgedG","forgedM","smooth"];
  const gripKeys=["smooth","perf","alcantara"];
  const allowed=key==="grip"?gripKeys:rimKeys;
  const items=allowed.map(k=>[k,MATS[k].name,"",MATS[k].price]);
  if(S[key] && !allowed.includes(S[key])){ S[key]=allowed[0]; S[colorKey]=0; }
  const el=$$(id); el.innerHTML="";
  items.forEach(it=>{
    const b=document.createElement("button");
    b.className="optcard"+(S[key]===it[0]?" sel":"");
    const label=priceText(it[3]);
    const imgFile=key==="grip"?MATS[it[0]].gripImg:MATS[it[0]].img;
    const mimg=imgFile?`<img class="matimg" src="${assetUrl(imgFile)}" alt="" loading="lazy">`:"";
    b.innerHTML=mimg+`<div class="t">${it[1]}</div>`+(label?`<div class="pr">${label}</div>`:"");
    b.onclick=()=>{S[key]=it[0]; S[colorKey]=0; matCards(id,key,colorKey); gripGate(); refresh();
      const noColor=(key!=="grip"&&["carbonG","carbonM","dryCarbonM","dryCarbonG"].includes(it[0]))||((MATS[it[0]].colors||[]).length<=1);
      if(noColor) advanceFrom(id);};
    el.appendChild(b);
  });
  // plain carbons have one factory look — no color picker (a single swatch
  // is auto-hidden by buildSwatches; the preview hex still reads colors[0])
  const NOCOLOR=["carbonG","carbonM","dryCarbonM","dryCarbonG"];
  // no material chosen yet -> no colour row to draw
  const mat=MATS[S[key]];
  const swColors=!mat?[]:(key!=="grip"&&NOCOLOR.includes(S[key])?mat.colors.slice(0,1):mat.colors);
  if(key!=="grip"&&NOCOLOR.includes(S[key])&&S[colorKey]!==0) S[colorKey]=0;
  buildSwatches("sw-"+key,swColors,colorKey);
}
function gripGate(){}

/* ================= conditional gates ================= */
function clearPickFlags(){
  root.querySelectorAll("fieldset.needs-pick").forEach(fs=>{
    if(fs.querySelector(".optcard.sel,.sw.sel")) fs.classList.remove("needs-pick");
  });
}
function afterChange(key){
  clearPickFlags();
  if(key==="trans"){
    if(S.trans==="manual"){ S.paddles="none"; }
    buildPaddleCards();
    gatePaddles();
  }
  if(key==="oemheat"){
    gateHeat();
  }
  if(key==="heat") gateHeat();
  refresh();
}
const AIRBAG_MATS=[
  ["smooth","Smooth leather","superauto-airbag-smooth.webp"],
  ["perf","Perforated leather","superauto-airbag-perf.webp"],
  ["alcantara","Alcantara","superauto-airbag-alcantara.webp"]
];
function airbagMatName(){
  const m=AIRBAG_MATS.find(x=>x[0]===S.airbagMat);
  return m ? m[1] : "";
}
function buildAirbagCards(){
  const el=$$("f-airbagmat"); if(!el) return;
  buildCards("f-airbagmat",AIRBAG_MATS.map(m=>[m[0],m[1],"",0,m[2]]),"airbagMat",
    it=>`<img class="matimg" src="${assetUrl(it[4])}" alt="" loading="lazy"><div class="t">${it[1]}</div>`,
    ()=>{const sw=$$("sw-airbagmat");return !sw||sw.hidden;}); // wait for the colour pick
}
function airbagColors(){ return MATS[S.airbagMat] ? MATS[S.airbagMat].colors : []; }
function airbagLabel(){
  if(!S.airbagCover) return "No";
  const n=airbagMatName(), c=airbagColors()[S.airbagColor];
  return n ? (c ? n+" — "+c[0] : n) : "Yes";
}
function syncAirbagUI(){
  const w=$$("wrap-airbagopts"); if(w) w.hidden=!S.airbagCover;
  const cols=S.airbagCover?airbagColors():[];
  if(S.airbagColor>=cols.length) S.airbagColor=0;
  buildSwatches("sw-airbagmat",cols,"airbagColor");
}
function buildPaddleCards(){
  buildCards("f-paddles",PADDLES.filter(p=>p[0]!=="none"),"paddles",
    it=>(it[4]?`<img class="matimg" src="${assetUrl(it[4])}" alt="" loading="lazy">`:"")
      +`<div class="t">${it[1]}</div>`+(priceText(it[3])?`<div class="pr">${priceText(it[3])}</div>`:""),
    false); // Magnetic Paddles sits below in the same question
}
function buildLedCards(){
  buildCards("f-ledkit",LEDKIT.filter(l=>l[0]!=="none"),"ledkit",
    it=>(it[4]?`<img class="matimg" src="${assetUrl(it[4])}" alt="" loading="lazy">`:"")
      +`<div class="t">${it[1]}${VIDEOS[it[0]]?` <span class="info-btn" data-video="${it[0]}" role="button" tabindex="0" aria-label="Watch a demo video">i</span>`:""}</div>`
      +(priceText(it[3])?`<div class="pr">${priceText(it[3])}</div>`:""));
}
function gateCollision(){
  const el=$$("f-collision"); if(!el) return;
  const fs=el.closest("fieldset");
  const bmw=/^bmw$/i.test(S.make||"");
  fs.hidden=!bmw;
  if(!bmw && S.collision){ S.collision=false; setYNUI("f-collision",false); }
}
function gatePaddles(){
  const manual=S.trans==="manual";
  // manual transmission: the whole question disappears (the transmission note
  // in step 1 tells the customer upfront)
  const fs=$$("wrap-paddles"); if(fs) fs.hidden=manual;
  $$("gate-paddles").hidden=true;
  if(manual){ S.paddleson=false; S.paddles="none"; S.magnetic=false; setYNUI("f-paddleson",false); setYNUI("f-magnetic",false); }
  $$("wrap-paddleopts").hidden=!S.paddleson;
}
// keep a toggle's buttons in sync when code (not a click) changes the answer
function setYNUI(id,val){
  const seg=$$(id) && $$(id).querySelector(".ynseg");
  if(!seg) return;
  [...seg.children].forEach(b=>b.classList.toggle("sel", b.classList.contains("yes")===!!val));
}
function gateHeat(){
  // no factory heating -> the heating add-on cannot be fitted: hide the
  // whole Heating fieldset and force the selection back to "none" so the
  // price, review, and payload never carry a stale heating line
  const fs=$$("f-heaton").closest("fieldset");
  const blocked=S.oemheat==="no";
  fs.hidden=blocked;
  if(blocked && (S.heaton || S.heat!=="none")){
    S.heaton=false; S.heat="none"; setYNUI("f-heaton",false);
  }
}
function buildHeat(){ gateHeat(); }

/* ================= refresh ================= */
function stepComplete(n){
  if(n===1 && !(S.year && S.make && S.model)) return false;
  return (STEP_REQUIRED[n]||[]).every(r=>hasAnswer(r[0]));
}
function updateStepCTA(){
  const idx=[...root.querySelectorAll(".cstep")].findIndex(p=>!p.hidden)+1;
  if(idx<1) return;
  const btn=root.querySelector("#cstep-"+idx+" .stepnav-right .btn.primary");
  if(btn) btn.classList.toggle("ready",stepComplete(idx));
}
function updateProgress(){
  const bar=$$("cfg-progbar"); if(!bar) return;
  const req=Object.values(STEP_REQUIRED).flat();
  const total=1+req.length;
  let done=(S.year&&S.make&&S.model)?1:0;
  req.forEach(r=>{ if(hasAnswer(r[0])) done++; });
  bar.style.width=Math.round(done/total*100)+"%";
}
function refresh(){
  if(typeof clearPickFlags==="function") clearPickFlags();
  if(typeof updateQFocus==="function") requestAnimationFrame(updateQFocus);
  if(typeof updateStepCTA==="function") updateStepCTA();
  if(typeof updateProgress==="function") updateProgress();
  const L=lines(), T=total();
  $$("pricelines").innerHTML=L.map(l=>`<div class="prow"><span>${l[0]}</span><span class="v">${lineValue(l)}</span></div>`).join("");
  $$("ptotal").textContent=money(T);
  { const pd=$$("pdeposit"); if(pd) pd.textContent="before build"; }
  $$("plead").textContent=lead();
  renderWheels();
}


/* ================= info video popovers ================= */
const VIDEOS={};
function initInfoVideos(){
  if(!root) return;
  if(root.dataset.videoLed24) VIDEOS.led24=root.dataset.videoLed24;
  if(root.dataset.videoLed50) VIDEOS.led50=root.dataset.videoLed50;
  const pop=document.createElement("div");
  pop.className="video-pop"; pop.hidden=true;
  pop.innerHTML='<video muted loop playsinline preload="none"></video>';
  document.body.appendChild(pop);
  const vid=pop.querySelector("video");
  let cur=null;
  const show=btn=>{
    const src=VIDEOS[btn.dataset.video]; if(!src) return;
    if(vid.getAttribute("src")!==src) vid.setAttribute("src",src);
    pop.hidden=false; cur=btn;
    const r=btn.getBoundingClientRect(), W=340, H=Math.round(W*544/960);
    const x=Math.min(Math.max(8,r.left+r.width/2-W/2), innerWidth-W-8);
    let y=r.bottom+10; if(y+H+10>innerHeight) y=r.top-H-10;
    pop.style.left=x+"px"; pop.style.top=y+"px"; pop.style.width=W+"px";
    vid.play().catch(()=>{});
  };
  const hide=()=>{ if(pop.hidden) return; pop.hidden=true; vid.pause(); cur=null; };
  document.addEventListener("pointerover",e=>{
    const b=e.target.closest(".info-btn");
    if(b) show(b);
    else if(cur && !e.target.closest(".video-pop")) hide();
  });
  document.addEventListener("click",e=>{
    const b=e.target.closest(".info-btn");
    if(b){ e.preventDefault(); e.stopPropagation(); (cur===b && !pop.hidden) ? hide() : show(b); }
    else if(!e.target.closest(".video-pop")) hide();
  },true);
  document.addEventListener("keydown",e=>{
    if(e.key==="Enter" && e.target.classList && e.target.classList.contains("info-btn")){ e.preventDefault(); e.stopPropagation(); show(e.target); }
  },true);
}
/* ================= navigation ================= */
let visited=1;
function go(name){
  if(root && root.dataset.mode==="waitlist" && name!=="landing"){
    const w=document.getElementById("waitlist"); if(w) w.scrollIntoView({behavior:"smooth"});
    return;
  }
  const OVERLAY={config:1};
  // phones: the popup is full-screen and opaque, so the pixel backdrop is invisible — skip its ~700 animated cells
  if(OVERLAY[name] && !pixelWheelBuilt && window.innerWidth>900){ pixelWheelBuilt=true; buildPixelWheel(); }
  root.querySelectorAll(".screen").forEach(s=>s.classList.remove("on"));
  if(OVERLAY[name]){
    $$("screen-landing").classList.add("on");   // landing stays visible beneath the popup
    $$("screen-"+name).classList.add("on");
    document.documentElement.style.overflow="hidden";
  }else{
    $$("screen-"+name).classList.add("on");
    document.documentElement.style.overflow="";
    window.scrollTo({top:0});
  }
  document.body.classList.toggle("in-config", name==="config");
  if(name==="landing") requestAnimationFrame(initReveals);
}
document.addEventListener("keydown",e=>{
  if(e.key==="Escape" && document.getElementById("screen-config") && document.getElementById("screen-config").classList.contains("on") && root && root.dataset.mode!=="waitlist") go("landing");
});
const STEPNAMES=["Vehicle","Shape & Feel","Materials & Colors","Finishes & Details","Functions","Review"];
const STEP_REQUIRED={
  1:[["trans","f-trans","Transmission"],["oemheat","f-oemheat","Heating"]],
  2:[["style","f-style","Design Style"],["thick","f-thick","Rim Thickness"]],
  3:[["mainTop","f-mainTop","Top Half"],["grip","f-grip","Grip"]],
  4:[["stitch","sw-stitch","Side Stitching Color"]]
};
// brief toast at the foot of the configurator naming what is still unanswered
var toastTimer;
function toast(msg){
  let el=$$("swc-toast");
  if(!el){
    el=document.createElement("div");
    el.id="swc-toast"; el.className="swc-toast"; el.setAttribute("role","status");
    document.body.appendChild(el);
  }
  el.textContent=msg;
  el.classList.remove("on"); void el.offsetWidth; el.classList.add("on");
  clearTimeout(toastTimer);
  toastTimer=setTimeout(()=>el.classList.remove("on"),4000);
}
function hideToast(){
  const el=$$("swc-toast");
  if(el){ clearTimeout(toastTimer); el.classList.remove("on"); }
}
function missingFor(step){
  return (STEP_REQUIRED[step]||[]).filter(([k])=>S[k]===""||S[k]==null);
}
function flagMissing(step){
  const miss=missingFor(step);
  miss.forEach(([,id])=>{
    const el=$$(id); if(!el) return;
    const fs=el.closest("fieldset"); if(fs) fs.classList.add("needs-pick");
  });
  if(miss.length){
    const names=miss.map(m=>m[2]);
    toast(names.length===1
      ? "Please choose "+names[0]+" to continue."
      : "Please choose "+names.slice(0,-1).join(", ")+" and "+names[names.length-1]+" to continue.");
    const first=$$(miss[0][1]).closest("fieldset");
    if(first) first.scrollIntoView({behavior:"smooth",block:"center"});
  }
  else hideToast();
  return miss.length===0;
}
/* focus follows scroll: the question nearest the focal line stays at full opacity.
   Answering a question pins focus to the next one (qFocusPin); a real user scroll
   (wheel/touch) releases the pin and the focal line takes over again. */
/* TEMP staging debug: tiny on-page log of the focus pipeline (remove before promoting) */
const QDBG=(()=>{ let el=null; const lines=[];
  const enabled=/swcdebug/.test(location.hash+location.search);
  function ensure(){ if(el) return el;
    el=document.createElement("div");
    el.style.cssText="position:fixed;left:6px;bottom:6px;z-index:99999;background:rgba(0,0,0,.85);color:#7CFC9A;font:10px/1.5 monospace;padding:6px 8px;border-radius:6px;max-width:72vw;pointer-events:none;white-space:pre-wrap";
    document.body.appendChild(el); return el; }
  return m=>{ try{ if(!enabled) return; lines.push(String(m).slice(0,90)); while(lines.length>8) lines.shift(); ensure().textContent=lines.join("\n"); }catch(e){} };
})();
window.addEventListener("error",e=>QDBG("ERR "+(e.message||"")+" @"+String(e.filename||"").split("/").pop().split("?")[0]+":"+e.lineno+":"+e.colno));
let qFocusPin=null;
let qPinGuard=0; // pin-protection window: stray touchmove around a pick must not clear a fresh pin
function updateQFocus(){
  const main=root.querySelector(".config-main"); if(!main) return;
  const panel=root.querySelector(".cstep:not([hidden])"); if(!panel) return;
  const fs=[...panel.querySelectorAll(":scope > fieldset")].filter(f=>!f.hidden);
  if(!fs.length) return;
  if(qFocusPin && (qFocusPin.hidden || !fs.includes(qFocusPin))){ QDBG("pin invalidated"); qFocusPin=null; }
  if(qFocusPin){
    fs.forEach(f=>f.classList.toggle("q-focus",f===qFocusPin));
    if(qFocusPin!==window.__lastPinLog){ window.__lastPinLog=qFocusPin; QDBG("focus(pin) -> "+(((qFocusPin.querySelector("legend")||qFocusPin.querySelector(".t"))||{}).textContent||"?").slice(0,18)); }
    return;
  }
  const mr=main.getBoundingClientRect();
  // the focal line slides with scroll progress so the first question wins at the
  // top and the last one wins at the bottom, even when the step barely scrolls
  const maxScroll=Math.max(0,main.scrollHeight-main.clientHeight);
  const prog=maxScroll>0?main.scrollTop/maxScroll:0;
  const lo=Math.min(100,mr.height*0.18), hi=mr.height-160;
  const focal=mr.top+lo+(Math.max(hi,lo)-lo)*prog;
  let best=null,bd=Infinity;
  // at the top of a step the first question always holds focus - on tall
  // screens the focal line can land past a short first row (e.g. a toggle)
  if(main.scrollTop<=2) best=fs[0];
  else
  fs.forEach(f=>{
    const r=f.getBoundingClientRect();
    const d=r.top>focal?r.top-focal:(r.bottom<focal?focal-r.bottom:0);
    if(d<bd){bd=d;best=f}
  });
  fs.forEach(f=>f.classList.toggle("q-focus",f===best));
  if(best!==window.__lastFocal){ window.__lastFocal=best; QDBG("focal -> "+(((best.querySelector("legend")||best.querySelector(".t"))||{}).textContent||"?").slice(0,18)); }
}
function toggleSteps(open){
  const side=root.querySelector(".config-side"), scrim=$$("cfg-scrim");
  if(!side) return;
  const on=open===undefined?!side.classList.contains("open"):!!open;
  side.classList.toggle("open",on);
  if(scrim) scrim.hidden=!on;
}
window.toggleSteps=toggleSteps;
function goStep(n){
  toggleSteps(false);
  // leaving a step forward requires its own answers first
  const cur=[...root.querySelectorAll(".cstep")].findIndex(p=>!p.hidden)+1;
  if(n>cur && cur>=1 && !flagMissing(cur)) return;
  if(n>1 && !(S.year && S.make && S.model)){
    ["f-year","f-make","f-model"].forEach(id=>{ const el=$$(id); if(el && !el.value) el.style.borderColor="#D6473A"; });
    const p=$$("cstep-1"); if(p && p.hidden){ root.querySelectorAll(".cstep").forEach((x,i)=>x.hidden=i!==0); }
    return;
  }
  if(n===6) renderReview();
  visited=Math.max(visited,n);
  setHL(null);
  root.querySelectorAll(".cstep").forEach((p,i)=>p.hidden=(i+1)!==n);
  const sb=$$("stepper"); sb.innerHTML="";
  STEPNAMES.forEach((nm,i)=>{
    const b=document.createElement("button");
    const st=i+1;
    b.className=(st===n?"cur":"")+(st<n?" done":"");
    b.disabled=st>visited;
    b.innerHTML=`<span class="dot">${st<n?"✓":st}</span>${nm}`;
    b.onclick=()=>goStep(st);
    sb.appendChild(b);
  });
  window.scrollTo({top:0});
  const cm=root.querySelector(".config-main"); if(cm) cm.scrollTop=0;
  qFocusPin=null;
  updateQFocus();
  updateStepCTA();
}

/* ================= review ================= */
const NOTSET="Not selected";
function pick(list,val){ const f=list.find(x=>x[0]===val); return f?f[1]:NOTSET; }
function matLabel(key,colorKey){ const m=MATS[S[key]]; if(!m) return NOTSET; const c=m.colors[S[colorKey]]; return c ? m.name+" — "+c[0] : m.name; }
function renderReview(){
  const T=total();
  const g=(title,step,rows)=>`
    <div class="revgroup"><div class="revhead"><h3>${title}</h3><button onclick="goStep(${step})">Edit</button></div>
    <div class="revrows">${rows.filter(r=>r[1]).map(r=>`<div class="revrow"><span class="k">${r[0]}</span><span class="v">${r[1]}</span></div>`).join("")}</div></div>`;
  $$("revgroups").innerHTML =
    g("Your Vehicle",1,[["Vehicle",S.year+" "+S.make+" "+S.model],["Transmission",pick(TRANS,S.trans)],["Factory heated wheel",S.oemheat?(S.oemheat==="yes"?"Yes":"No / not sure"):NOTSET]])+
    g("Shape & Feel",2,[["Design style",pick(STYLES,S.style)],["Thickness",pick(THICK,S.thick)]])+
    g("Materials & Colors",3,[["Top half",matLabel("mainTop","mainTopColor")],["Bottom half",S.same?"Same as top":matLabel("mainBot","mainBotColor")],["Half wrap",S.halfwrap?"Yes":"No"],["Grip",matLabel("grip","gripColor")]])+
    g("Finishes & Details",4,[["Side stitching",S.stitch==null?NOTSET:STITCH[S.stitch][0]],["Center stripe",S.stripe?"Yes — "+STRIPES[S.stripecolor][0]:"No"],["Center trim",trimLabel()],["Thumb-grip inlays",inlayLabel()],["Airbag cover",airbagLabel()]])+
    g("Functions & Electronics",5,[["Paddle shifters",S.paddleson?pick(PADDLES,S.paddles):"No"],["Magnetic paddles",S.paddleson?(S.magnetic?"Yes":"No"):""],["Heating",S.heaton?"Yes":"No"],["LED RPM Display",S.ledon?pick(LEDKIT,S.ledkit):"No"],["BMW M-mode buttons / module",S.collision?"Yes":"No"],["Instructions",S.notes||"—"]]);
}


function buildQuoteSummary(){
  const rows=[
    ["Vehicle",S.year+" "+S.make+" "+S.model],
    ["Transmission",pick(TRANS,S.trans)],
    ["Factory heated wheel",S.oemheat?(S.oemheat==="yes"?"Yes":"No / not sure"):NOTSET],
    ["Design style",pick(STYLES,S.style)],
    ["Thickness",pick(THICK,S.thick)],
    ["Top half",matLabel("mainTop","mainTopColor")],
    ["Bottom half",S.same?"Same as top":matLabel("mainBot","mainBotColor")],
    ["Half wrap",S.halfwrap?"Yes":"No"],
    ["Grip",matLabel("grip","gripColor")],
    ["Center trim",trimLabel()],
    ["Thumb-grip inlays",inlayLabel()],
    ["Side stitching",S.stitch==null?NOTSET:STITCH[S.stitch][0]],
    ["Center stripe",S.stripe?"Yes — "+STRIPES[S.stripecolor][0]:"No"],
    ["Paddle shifters",S.paddleson?pick(PADDLES,S.paddles):"No"],
    ["Magnetic paddles",S.paddleson?(S.magnetic?"Yes":"No"):"No"],
    ["Heating",S.heaton?"Yes":"No"],
    ["LED RPM Display",S.ledon?pick(LEDKIT,S.ledkit):"No"],
    ["BMW M-mode buttons / module",S.collision?"Yes":"No"],
    ["Airbag cover",airbagLabel()],
    ["Instructions",S.notes||"—"],
    ["Estimated starting price",money(total())],
    ["Process time",lead()]
  ];
  return rows.map(r=>r[0]+": "+r[1]).join("\n");
}
function formValue(form,name){
  const input=form ? form.elements[name] : null;
  return input && input.value ? input.value.trim() : "";
}
function requestId(){
  const d=new Date();
  const stamp=d.getFullYear().toString()+String(d.getMonth()+1).padStart(2,"0")+String(d.getDate()).padStart(2,"0");
  return "NNX-"+stamp+"-"+Math.random().toString(36).slice(2,7).toUpperCase();
}
function buildSheetPayload(form){
  const id=requestId();
  return {
    submitted_at:new Date().toISOString(),
    request_id:id,
    status:"Payment pending",
    customer_name:formValue(form,"contact[name]"),
    customer_email:formValue(form,"contact[email]"),
    phone:formValue(form,"contact[phone]"),
    shipping_address:formValue(form,"contact[shipping_address]"),
    city:formValue(form,"contact[city]"),
    state:formValue(form,"contact[state]"),
    zip:formValue(form,"contact[zip]"),
    vehicle_year:S.year,
    vehicle_make:S.make,
    vehicle_model:S.model,
    transmission:pick(TRANS,S.trans),
    factory_heated_wheel:S.oemheat?(S.oemheat==="yes"?"Yes":"No / not sure"):NOTSET,
    design_style:pick(STYLES,S.style),
    thickness:pick(THICK,S.thick),
    top_half:matLabel("mainTop","mainTopColor"),
    bottom_half:S.same?"Same as top":matLabel("mainBot","mainBotColor"),
    grip:matLabel("grip","gripColor"),
    center_trim:trimLabel(),
    thumb_inlays:inlayLabel(),
    side_stitching:S.stitch==null?NOTSET:STITCH[S.stitch][0],
    center_stripe:S.stripe?"Yes - "+STRIPES[S.stripecolor][0]:"No",
    paddle_shifters:S.paddleson?pick(PADDLES,S.paddles):"No",
    magnetic_paddles:S.paddleson&&S.magnetic?"Yes":"No",
    heating:S.heaton?"Yes":"No",
    led_rpm_display:S.ledon?pick(LEDKIT,S.ledkit):"No",
    m_mode_module:S.collision?"Yes":"No",
    airbag_cover:airbagLabel(),
    notes:S.notes||"",
    starting_estimate:money(total()),
    build_time:lead(),
    source_url:window.location.href,
    payment_url:root && root.dataset.paymentUrl ? root.dataset.paymentUrl.trim() : "",
    build_summary:buildQuoteSummary(),
    raw_json:JSON.stringify({state:S,price_lines:lines().map(l=>({label:l[0],value:lineValue(l)}))})
  };
}
async function sendSheetRequest(payload,opts){
  const sheetUrl=(root && root.dataset.sheetUrl ? root.dataset.sheetUrl.trim() : "");
  if(!sheetUrl) return false;
  const fd=new FormData();
  fd.append("payload",JSON.stringify(payload));
  if(root && root.dataset.sheetToken) fd.append("token",root.dataset.sheetToken);
  await fetch(sheetUrl,Object.assign({method:"POST",mode:"no-cors",body:fd,credentials:"omit"},opts||{}));
  return true;
}
/* ============ review → checkout (no separate contact screen; Shopify checkout collects contact/shipping) ============ */
function setBusy(btn,isBusy){
  if(!btn) return;
  btn.disabled=isBusy;
  if(isBusy){ btn.dataset.label=btn.textContent; btn.textContent="Preparing checkout…"; }
  else if(btn.dataset.label){ btn.textContent=btn.dataset.label; }
}
/* Compress image uploads (≤1600px JPEG) so they travel to the Sheet quickly; pass svg/pdf through raw. */
function encodeOneFile(file){
  return new Promise(resolve=>{
    if(!file){ resolve(null); return; }
    const raw=()=>{ const r=new FileReader();
      r.onload=()=>resolve({name:file.name,type:file.type||"application/octet-stream",data:String(r.result).split(",")[1]||""});
      r.onerror=()=>resolve(null); r.readAsDataURL(file); };
    if(!/^image\/(jpe?g|png|webp)$/i.test(file.type)){ if(file.size<=8*1024*1024) raw(); else resolve(null); return; }
    const img=new Image();
    img.onload=()=>{
      const MAX=1600, sc=Math.min(1,MAX/Math.max(img.width,img.height));
      const c=document.createElement("canvas");
      c.width=Math.round(img.width*sc); c.height=Math.round(img.height*sc);
      c.getContext("2d").drawImage(img,0,0,c.width,c.height);
      resolve({name:file.name.replace(/\.[a-z]+$/i,"")+".jpg",type:"image/jpeg",data:c.toDataURL("image/jpeg",0.85).split(",")[1]});
      URL.revokeObjectURL(img.src);
    };
    img.onerror=()=>raw();
    img.src=URL.createObjectURL(file);
  });
}
async function encodeFiles(){
  const src=S.fileObjs||{};
  const out={};
  for(const key of ["current"]){
    const enc=await encodeOneFile(src[key]);
    if(enc) out[key]=enc;
  }
  return out;
}
let checkoutStarting=false;
let draftSaving=false;
async function saveDraft(btn){
  if(draftSaving) return; draftSaving=true;
  setBusy(btn,true);
  const payload=buildSheetPayload(null);
  const baseRes=resolveBase();
  const up=resolveUpgrades();
  const ok=baseRes && baseRes.id && !up.missing.length && !up.mispriced.length;
  if(!ok){
    toast("We couldn't save this draft right now. Please try again or contact us.");
    draftSaving=false; setBusy(btn,false);
    return;
  }
  const req={}; if(payload.request_id) req["_Request ID"]=String(payload.request_id);
  const props=cartProps(payload); props["_Draft"]="Yes";
  const body={items:[
    {id:baseRes.id,quantity:1,properties:props},
    ...up.items.map(it=>({...it,properties:req}))
  ]};
  try{
    const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)});
    if(!r.ok) throw new Error("cart-add-failed");
    await r.json();
    go("landing");
    toast("Draft saved. Your build is waiting in the cart.");
  }catch(e){
    toast("We couldn't save this draft. Please try again.");
  }
  draftSaving=false; setBusy(btn,false);
}
async function startCheckout(btn){
  if(checkoutStarting) return; checkoutStarting=true;
  setBusy(btn,true);
  const payload=buildSheetPayload(null);
  const idEl=$$("progressRequestId");
  if(idEl) idEl.textContent="#"+payload.request_id;
  const depositVariantId=root && root.dataset.depositVariantId ? root.dataset.depositVariantId.trim() : "";
  const paymentUrl=root && root.dataset.paymentUrl ? root.dataset.paymentUrl.trim() : "";
  try{
    // Sheet = build dossier (spec + photos), keyed by request_id. Best-effort with a
    // time cap — a logging hiccup must never block a paying customer.
    const sheetUrl=(root && root.dataset.sheetUrl ? root.dataset.sheetUrl.trim() : "");
    if(sheetUrl){
      const files=await Promise.race([encodeFiles(),new Promise(r=>setTimeout(()=>r({}),8000))]);
      await Promise.race([sendSheetRequest({...payload,files}),new Promise(r=>setTimeout(r,12000))]);
    }
  }catch(e){ /* best-effort only */ }
  const baseRes=resolveBase();
  if(baseRes){
    addToCartAndCheckout(baseRes,payload,btn);
  }else if(paymentUrl){
    window.location.href=paymentUrl;
  }else{
    checkoutStarting=false; setBusy(btn,false);
    go("progress");
  }
}
/* Build concise, human-readable line-item properties (shown on the order + at checkout). */
function cartProps(payload){
  const p={};
  const put=(label,val)=>{ const s=(val==null?"":String(val)).trim(); if(s && s!=="No") p[label]=s; };
  put("Vehicle",[payload.vehicle_year,payload.vehicle_make,payload.vehicle_model].filter(Boolean).join(" "));
  put("Transmission",payload.transmission);
  put("Design style",payload.design_style);
  put("Rim thickness",payload.thickness);
  put("Top half",payload.top_half);
  put("Bottom half",payload.bottom_half);
  put("Grip",payload.grip);
  put("Center trim",payload.center_trim);
  put("Thumb inlays",payload.thumb_inlays);
  put("Side stitching",payload.side_stitching);
  put("Center stripe",payload.center_stripe);
  put("Paddle shifters",payload.paddle_shifters);
  put("Heating",payload.heating);
  put("LED RPM Display",payload.led_rpm_display);
  put("M-mode buttons / module",payload.m_mode_module);
  put("Airbag cover",payload.airbag_cover);
  put("Notes",payload.notes);
  put("Configured total",payload.starting_estimate);
  if(payload.request_id) p["_Request ID"]=String(payload.request_id); // hidden from customer, kept on order
  return p;
}
/* ===== itemized checkout: base product + one line per priced upgrade ===== */
/* Which upgrade variants (by name + expected price) the current build requires. */
function neededUpgrades(){
  // Titles must match the variants on the "Customized Steering Wheel Upgrade" product.
  const need=[];
  const forged=k=>k==="forgedG"||k==="forgedM";
  const dry=k=>k==="dryCarbonM"||k==="dryCarbonG";
  if(forged(S.mainTop)||(!S.same&&forged(S.mainBot))) need.push(["Upper & Lower Rim - Forged Carbon",100]);
  if(dry(S.mainTop)||(!S.same&&dry(S.mainBot))) need.push(["Upper & Lower Rim - Dry Carbon",50]);
  if(S.halfwrap) need.push(["Upper & Lower Rim - Half Wrap",100]);
  if(S.grip==="alcantara") need.push(["Hand Grip - Alcantara",70]);
  if(S.inlays) need.push(["Hand Grip - Grip Inlay",70]);
  if(S.paddleson && S.paddles!=="none"){
    const pd=PADDLES.find(p=>p[0]===S.paddles);
    if(pd && pd[5]) need.push([pd[5],pd[3]]);
    if(S.magnetic) need.push(PADDLE_MAGNET.slice());
  }
  if(S.heat==="yes") need.push(["Heating",100]);
  if(S.ledkit==="led24") need.push(["LED - 24 Lights",150]);
  if(S.ledkit==="led50") need.push(["LED - 50 Lights",200]);
  if(S.collision) need.push(["BMW M-Mode Buttons",100]);
  if(S.airbagCover) need.push(["Airbag Cover",120]);
  return need;
}
/* Match needed upgrades against the store's variants (rendered server-side).
   Tolerant of dash/spacing/case differences; strict about presence and price. */
function resolveUpgrades(){
  const norm=s=>String(s).toLowerCase().replace(/[—–]/g,"-").replace(/\s*-\s*/g,"-").replace(/\s+/g," ").trim();
  let variants=[];
  const el=root ? root.querySelector("[data-upgrade-variants]") : null;
  if(el){ try{ variants=JSON.parse(el.textContent); }catch(e){} }
  const items=[], missing=[], mispriced=[];
  for(const [title,expected] of neededUpgrades()){
    const v=variants.find(x=>norm(x.title)===norm(title));
    if(!v){ missing.push(title); continue; }
    if(Number(v.price)!==expected){ mispriced.push(title+" (store $"+v.price+" vs configured $"+expected+")"); continue; }
    items.push({id:Number(v.id),quantity:1});
  }
  return {items,missing,mispriced};
}
/* Pick the right base variant for the chosen vehicle (C8 vs standard). */
function resolveBase(){
  let vs=[];
  const el=root ? root.querySelector("[data-base-variants]") : null;
  if(el){ try{ vs=JSON.parse(el.textContent); }catch(e){} }
  const isC8=/c8/i.test(S.model||"");
  if(!vs.length){
    const id=root && root.dataset.depositVariantId ? root.dataset.depositVariantId.trim() : "";
    if(!id) return null;
    if(isC8) return {missing:"C8 Build (base $499)"};
    return {id:Number(id)};
  }
  const hasC8=t=>String(t).toLowerCase().includes("c8");
  const want=isC8 ? vs.find(v=>hasC8(v.title)) : (vs.find(v=>!hasC8(v.title))||vs[0]);
  const expected=basePrice();
  if(!want) return {missing:(isC8?"C8 Build (base $499)":"Standard base ($399)")};
  if(Number(want.price)!==expected) return {mispriced:"Base \""+want.title+"\" (store $"+want.price+" vs expected $"+expected+")"};
  return {id:Number(want.id)};
}
function addToCartAndCheckout(baseRes,payload,btn){
  const up=resolveUpgrades();
  if(baseRes && baseRes.missing) up.missing.unshift(baseRes.missing);
  if(baseRes && baseRes.mispriced) up.mispriced.unshift(baseRes.mispriced);
  if(up.missing.length||up.mispriced.length){
    alert("Checkout is temporarily unavailable — store configuration issue:\n"+
      (up.missing.length?"Missing upgrade options: "+up.missing.join(", ")+"\n":"")+
      (up.mispriced.length?"Price mismatch: "+up.mispriced.join(", ")+"\n":"")+
      "Please contact us and we'll finish your order.");
    checkoutStarting=false; setBusy(btn,false);
    return;
  }
  const req={};
  if(payload.request_id) req["_Request ID"]=String(payload.request_id);
  const body={items:[
    {id:baseRes.id,quantity:1,properties:cartProps(payload)},
    ...up.items.map(it=>({...it,properties:req}))
  ]};
  fetch("/cart/clear.js",{method:"POST"})
    .then(()=>fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)}))
    .then(r=>{ if(!r.ok) throw new Error("cart-add-failed"); return r.json(); })
    .then(()=>{ window.location.href="/checkout"; })
    .catch(()=>{
      alert("We couldn't start checkout. Please try again.");
      checkoutStarting=false;
      setBusy(btn,false);
    });
}

/* ================= uploads ================= */
function bindFile(inputId, btnId, key){
  $$(inputId).addEventListener("change",e=>{
    const f=e.target.files[0]; if(!f) return;
    S.files[key]=f.name;
    (S.fileObjs=S.fileObjs||{})[key]=f; // keep the real file so it can travel with the build request
    const b=$$(btnId); b.classList.add("has"); b.textContent="✓ "+f.name+" — click to replace";
  });
}

/* ================= scroll effects ================= */
let revealObserver=null;
function initReveals(){
  root.querySelectorAll(".rv").forEach(el=>el.classList.remove("on"));
  if(revealObserver) revealObserver.disconnect();
  if(!("IntersectionObserver" in window)){ root.querySelectorAll(".rv").forEach(el=>el.classList.add("on")); return; }
  revealObserver=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add("on"); revealObserver.unobserve(e.target); } });
  },{threshold:.16, rootMargin:"0px 0px -8% 0px"});
  root.querySelectorAll(".rv").forEach(el=>revealObserver.observe(el));
}
function initHeroWheelCarousel(){
  const carousel=root.querySelector("[data-hero-wheel-carousel]");
  if(!carousel || carousel.dataset.ready==="1") return;
  carousel.dataset.ready="1";
  const slides=[...carousel.querySelectorAll("[data-hero-wheel-slide]")];
  if(!slides.length) return;
  const reduce=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let activeIndex=0;
  let autoplayTimer=null;
  function signedOffset(index){
    const total=slides.length;
    let offset=index-activeIndex;
    if(offset>total/2) offset-=total;
    if(offset<total/-2) offset+=total;
    return offset;
  }
  function renderSlides(){
    slides.forEach((slide,index)=>{
      const offset=signedOffset(index);
      const active=offset===0;
      const abs=Math.abs(offset);
      slide.classList.toggle("is-active",active);
      if(active){ const im=slide.querySelector("img");
        // hand the browser every size and let it pick for this screen/DPR
        if(im.dataset.srcset && !im.getAttribute("srcset")){
          im.setAttribute("sizes","(max-width:900px) 46vw, 560px");
          im.setAttribute("srcset",im.dataset.srcset);
        } }
      slide.dataset.offset=String(offset);
      slide.style.order=String(offset+slides.length);
      slide.style.setProperty("--scale",abs===1 ? .9 : .76);
      slide.setAttribute("aria-current",active?"true":"false");
    });
  }
  function goToSlide(index){
    activeIndex=(index+slides.length)%slides.length;
    renderSlides();
  }
  function stopAutoplay(){ clearInterval(autoplayTimer); }
  function startAutoplay(){
    stopAutoplay();
    if(reduce || slides.length<2) return;
    autoplayTimer=setInterval(()=>goToSlide(activeIndex+1),3200);
  }
  slides.forEach((slide,index)=>{
    slide.addEventListener("click",()=>{
      goToSlide(index);
      startAutoplay();
    });
  });
  renderSlides();
  startAutoplay();
  carousel.addEventListener("mouseenter",stopAutoplay);
  carousel.addEventListener("mouseleave",startAutoplay);
  carousel.addEventListener("focusin",stopAutoplay);
  carousel.addEventListener("focusout",startAutoplay);
  document.addEventListener("visibilitychange",()=>{document.hidden?stopAutoplay():startAutoplay();});
}
function initScrollFX(){
  const heroWheel=$$("heroWheelCarousel");
  const heroCopy=$$("heroCopy");
  const reduce=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let ticking=false;
  function onScroll(){
    if(ticking) return; ticking=true;
    requestAnimationFrame(()=>{
      const y=window.scrollY;
      if(!reduce && heroWheel && $$("screen-landing").classList.contains("on")){
        // desktop card mode centres the carousel with translate(-50%,-50%);
        // the parallax must preserve that or the stack jumps on first scroll
        const centered=window.matchMedia("(min-width:901px)").matches;
        heroWheel.style.transform=centered
          ? `translate(-50%,calc(-50% + ${y*0.06}px)) scale(${1+y*0.0002})`
          : `translate(-50%,${y*0.06}px) scale(${1+y*0.0002})`;
        heroWheel.style.opacity=Math.max(0.35,1-y/500);
        const f=Math.max(0,1-y/460);
        heroCopy.style.transform=`translateY(${y*-0.06}px)`;
        heroCopy.style.opacity=f;
      }
      ticking=false;
    });
  }
  window.addEventListener("scroll",onScroll,{passive:true});
  onScroll();
}

/* ================= gallery filmstrip ================= */
function initStrip(){
  const track=$$("gsTrack"); if(!track) return;
  const items=[...track.querySelectorAll(".gs-item")];
  const reduce=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let idx=1, paused=false, timer=null;
  function centerOf(el){const r=el.getBoundingClientRect();return r.left+r.width/2;}
  function update(){
    const mid=centerOf(track);
    let best=null,bd=Infinity,bi=0;
    items.forEach((it,i)=>{const d=Math.abs(centerOf(it)-mid);if(d<bd){bd=d;best=it;bi=i}});
    items.forEach(it=>it.classList.toggle("on",it===best));
    if(best){$$("gsCapTitle").textContent=best.dataset.title;idx=bi;}
  }
  function centerItem(i,smooth){
    const it=items[i]; if(!it) return;
    const left=it.offsetLeft + it.offsetWidth/2 - track.clientWidth/2;
    track.scrollTo({left:left,behavior:(smooth&&!reduce)?"smooth":"auto"});
  }
  function advance(){ if(paused) return; idx=(idx+1)%items.length; centerItem(idx,true); }
  track.addEventListener("scroll",()=>{clearTimeout(track._t);track._t=setTimeout(update,70)},{passive:true});
  items.forEach((it,i)=>it.addEventListener("click",()=>centerItem(i,true)));
  /* pause auto-play while the visitor is interacting */
  const strip=track.closest(".gallery-strip");
  strip.addEventListener("pointerenter",()=>paused=true);
  strip.addEventListener("pointerleave",()=>paused=false);
  /* start centered on the 2nd image, then auto-advance (unless reduced motion) */
  setTimeout(()=>{
    centerItem(1,false); update();
    if(!reduce) timer=setInterval(advance,3200);
  },80);
}

/* ================= how it works: split-line progress bar ================= */
function initHiw(){
  const fill=$$("hiwFill");
  const hiw=$$("superauto-how");
  if(!hiw) return;
  const steps=[...root.querySelectorAll(".hiw2-step")];
  function upd(){
    if(fill){
      const pinStart=window.scrollY + hiw.getBoundingClientRect().top;   // doc offset of section top
      const dur=Math.max(1, hiw.offsetHeight - window.innerHeight);       // scroll distance while pinned
      const p=Math.min(1, Math.max(0,(window.scrollY - pinStart)/dur));
      fill.style.transform="scaleY("+p.toFixed(4)+")";
    }
    /* fade + slide each step in once it enters the viewport */
    const vh=window.innerHeight;
    steps.forEach(s=>{
      if(s.classList.contains("in")) return;
      const r=s.getBoundingClientRect();
      if(r.top < vh*0.80 && r.bottom > vh*0.12) s.classList.add("in");
    });
  }
  window.addEventListener("scroll",upd,{passive:true});
  window.addEventListener("resize",upd);
  upd();
}

/* ================= init ================= */
function onMake(){
  const mk=$$("f-make"), md=$$("f-model");
  S.make=mk.value; md.innerHTML="";
  const ph=document.createElement("option"); ph.value=""; ph.disabled=true; ph.selected=true; ph.textContent="Model"; md.appendChild(ph);
  (MAKES[S.make]||[]).forEach(m=>{const o=document.createElement("option");o.value=o.textContent=m;md.appendChild(o);});
  S.model=""; md.onchange=()=>{S.model=md.value; md.style.borderColor=""; refresh(); if(S.year&&S.make&&S.model){ QDBG("fitment complete"); advanceFrom("f-year"); }};
  gateCollision();
  refresh();
}
function init(){
  // touching a question focuses it - without this, the sticky mobile pin left
  // earlier questions dim even while the user was interacting with them
  root.addEventListener("pointerdown",e=>{
    const f=e.target.closest(".cstep fieldset");
    if(!f || f.hidden || f.classList.contains("q-focus")) return;
    if(Date.now()<qPinGuard) return; // ignore ghost taps right after an auto-advance
    qFocusPin=f; updateQFocus();
  },{passive:true});
  const cmain=root.querySelector(".config-main");
  if(cmain){
    cmain.addEventListener("scroll",()=>{
      if(cmain._qf) return;
      cmain._qf=requestAnimationFrame(()=>{cmain._qf=0;updateQFocus()});
    },{passive:true});
    // desktop: a wheel scroll hands focus back to the focal line. On touch
    // devices the pin persists - answered questions collapse there, so the one
    // open question should stay highlighted until the next answer or tap.
    cmain.addEventListener("wheel",()=>{ if(Date.now()<qPinGuard) return; if(qFocusPin) QDBG("pin cleared (wheel)"); qFocusPin=null; },{passive:true});
  }
  const phOpt=(sel,label)=>{const o=document.createElement("option");o.value="";o.disabled=true;o.selected=true;o.textContent=label;sel.appendChild(o);};
  const y=$$("f-year"); phOpt(y,"Year"); for(let yr=2026;yr>=1995;yr--){const o=document.createElement("option");o.value=o.textContent=yr;y.appendChild(o);} y.onchange=()=>{S.year=y.value; y.style.borderColor=""; refresh(); if(S.year&&S.make&&S.model){ QDBG("fitment complete"); advanceFrom("f-year"); }};
  const mk=$$("f-make"); phOpt(mk,"Make"); Object.keys(MAKES).forEach(m=>{const o=document.createElement("option");o.value=o.textContent=m;mk.appendChild(o);});
  const mdInit=$$("f-model"); phOpt(mdInit,"Model");
  initInfoVideos();
  buildCards("f-trans",TRANS,"trans",it=>`<div class="t">${it[1]}</div><div class="d">${it[2]}</div>`);
  buildCards("f-oemheat",OEMHEAT,"oemheat",it=>`<div class="t">${it[1]}</div>`);
  buildCards("f-style",STYLES,"style",it=>`<img class="styleimg" src="${assetUrl(it[4])}" alt="" loading="lazy"><div class="t">${it[1]}</div>`+(it[3]!==0?`<div class="pr">${priceText(it[3])}</div>`:""));
  buildCards("f-thick",THICK,"thick",it=>`<div class="t">${it[1]}</div><div class="d">${it[2]}</div>`+(it[3]!==0?`<div class="pr">${priceText(it[3])}</div>`:""));
  matCards("f-mainTop","mainTop","mainTopColor");
  matCards("f-mainBot","mainBot","mainBotColor");
  matCards("f-grip","grip","gripColor");
  gripGate();
  buildCards("f-bottomTrim",TRIM_B.map(t=>[t[0],t[0],"",t[1],t[2]]),"bottomTrim",
    it=>(it[4]?`<img class="matimg" src="${assetUrl(it[4])}" alt="" loading="lazy">`:"")
      +`<div class="t">${it[1]}</div>`+(priceText(it[3])?`<div class="pr">${priceText(it[3])}</div>`:""),
    ()=>{const sw=$$("sw-bottomTrim");return !sw||sw.hidden;}); // wait for the colour pick
  buildCards("f-thumbinlay",THUMB_INLAYS,"thumbinlay",
    it=>(it[4]?`<img class="matimg" src="${assetUrl(it[4])}" alt="" loading="lazy">`:"")+`<div class="t">${it[1]}</div>`,
    ()=>{const w=$$("wrap-inlayflake");return !w||w.hidden;}); // wait for the flake pick
  buildPhotoCards("sw-stitch",STITCH,"stitch");
  buildStripeCards();
  buildPaddleCards();
  buildLedCards();
  buildAirbagCards();
  syncAirbagUI();
  gateCollision();
  buildHeat();
  syncTrimUI();
  const cfg=$$("screen-config");
  ["pointerover","focusin"].forEach(ev=>cfg.addEventListener(ev,e=>{
    const t=e.target.closest("[data-part]");
    setHL(t?t.dataset.part:null);
  }));
  cfg.addEventListener("pointerleave",()=>setHL(null));
  goStep(1);
  refresh();
  initHeroWheelCarousel();
  initScrollFX();
  initReveals();
  initStrip();
  initHiw();
}
/* ================= waitlist ================= */
const WL_MAKES = {
  "Acura":["TLX","Integra"],
  "BMW":["X5 (G05)","M3","M4","3 Series"],
  "Cadillac":["CT4","CT5"],
  "Chevrolet":["Corvette","Camaro"],
  "Dodge":["Charger","Challenger"],
  "Ford":["Mustang"],
  "Honda":["Civic","Accord"],
  "Hyundai":["Elantra N","Veloster N"],
  "INEOS":["Grenadier"],
  "Mazda":["MX-5 Miata","Mazda3"],
  "Nissan":["Altima","Z"],
  "Subaru":["WRX","WRX STI","BRZ","Impreza WRX","Impreza WRX STI"],
  "Tesla":["Model 3","Model Y"],
  "Toyota":["86","GR86","Supra","GR Corolla"],
  "Other":["My vehicle isn\u2019t listed"]
};
function initWaitlist(){
  if(!root || root.dataset.mode!=="waitlist") return;
  const y=$$("wl-year"), mk=$$("wl-make"), md=$$("wl-model");
  if(!y||!mk||!md) return;
  const ph=(sel,label)=>{ const o=document.createElement("option"); o.value=""; o.disabled=true; o.selected=true; o.textContent=label; sel.appendChild(o); };
  ph(y,"Year"); for(let yr=2026;yr>=1995;yr--){const o=document.createElement("option");o.value=o.textContent=yr;y.appendChild(o);}
  ph(mk,"Make"); Object.keys(WL_MAKES).forEach(m=>{const o=document.createElement("option");o.value=o.textContent=m;mk.appendChild(o);});
  const fillModels=()=>{ md.innerHTML=""; ph(md,"Model"); (WL_MAKES[mk.value]||[]).forEach(m=>{const o=document.createElement("option");o.value=o.textContent=m;md.appendChild(o);}); };
  ph(md,"Model");
  const oth=$$("wl-other");
  mk.onchange=()=>{ fillModels(); const isOther=mk.value==="Other"; md.hidden=isOther; if(oth) oth.hidden=!isOther; };
  if(/contact_posted=true/.test(location.search)){
    const f=root.querySelector(".wl-form"); if(f) f.hidden=true;
    const d=$$("wl-done"); if(d) d.hidden=false;
    setTimeout(()=>{ const card=document.getElementById("waitlist"); if(card) card.scrollIntoView({behavior:"smooth"}); }, 300);
  }
}
function submitWaitlist(btn){
  const mark=(el,bad)=>{ if(el) el.style.borderColor=bad?"#D6473A":""; return !bad; };
  let ok=true;
  ok=mark($$("wl-year"),!$$("wl-year").value)&&ok;
  ok=mark($$("wl-make"),!$$("wl-make").value)&&ok;
  const isOther=$$("wl-make").value==="Other";
  ok=mark($$("wl-model"),!isOther && !$$("wl-model").value)&&ok;
  if(isOther) ok=mark($$("wl-other"),!($$("wl-other").value||"").trim())&&ok;
  const emailEl=$$("wl-email");
  const email=(emailEl.value||"").trim();
  ok=mark(emailEl,!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email))&&ok;
  const phoneEl=$$("wl-phone");
  const phone=(phoneEl.value||"").trim();
  ok=mark(phoneEl,!/^[+\d][\d\s().-]{6,}$/.test(phone))&&ok;
  if(!ok) return;
  const payload={
    submitted_at:new Date().toISOString(),
    request_id:requestId(),
    status:"Waitlist",
    customer_email:email,
    phone:phone,
    vehicle_year:$$("wl-year").value, vehicle_make:$$("wl-make").value, vehicle_model:(isOther ? $$("wl-other").value.trim() : $$("wl-model").value),
    notes:($$("wl-notes").value||"").trim(),
    source_url:window.location.href,
    build_summary:"Waitlist signup",
    raw_json:JSON.stringify({type:"waitlist"})
  };
  if(btn){ btn.disabled=true; btn.textContent="Joining\u2026"; }
  const done=()=>{ const f=root.querySelector(".wl-form"); if(f) f.hidden=true; const d=$$("wl-done"); if(d) d.hidden=false; openWaitlistModal(); };
  const sheetUrl=(root && root.dataset.sheetUrl ? root.dataset.sheetUrl.trim() : "");
  if(sheetUrl){
    // Optimistic: confirm instantly; the request delivers in the background.
    // keepalive keeps it alive even if the visitor navigates right away.
    sendSheetRequest(payload,{keepalive:true}).catch(()=>fallbackContact(payload,null));
    setTimeout(done,250);
  }else{
    fallbackContact(payload,done);
  }
}
/* No Sheet configured: submit Shopify's contact form via AJAX (arrives at the store email),
   then show the inline confirmation — no page navigation. */
function fallbackContact(payload,done){
  const fd=new URLSearchParams();
  fd.append("form_type","contact"); fd.append("utf8","\u2713");
  fd.append("contact[email]",payload.customer_email);
  if(payload.phone) fd.append("contact[phone]",payload.phone);
  fd.append("contact[subject]","Steering wheel waitlist signup");
  fd.append("contact[body]","Waitlist signup\nVehicle: "+payload.vehicle_year+" "+payload.vehicle_make+" "+payload.vehicle_model+"\nPhone: "+(payload.phone||"\u2014")+"\nRequirements: "+(payload.notes||"\u2014")+"\nRequest ID: "+payload.request_id);
  fetch("/contact",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:fd.toString(),redirect:"follow"})
    .catch(()=>{})
    .finally(()=>{ if(done) done(); });
}
function openWaitlistModal(){ const m=$$("wl-modal"); if(m) m.hidden=false; document.documentElement.style.overflow="hidden"; }
function closeWaitlistModal(){ const m=$$("wl-modal"); if(m) m.hidden=true; document.documentElement.style.overflow=""; }
/* ===== pixel wheel backdrop: stylized 8-bit wheel, edge pixels breathe ===== */
var pixelWheelBuilt=false;
function buildPixelWheel(){
  const host=$$("pixelWheel");
  if(!host || host.childElementCount) return;
  const N=40, cell=100/N;
  const inShape=(cx,cy)=>{
    const r=Math.hypot(cx,cy);
    if(r>=0.60 && r<=0.92) return true;                        // rim
    if(r<=0.26) return true;                                   // hub
    if(Math.abs(cy)<=0.11 && Math.abs(cx)>=0.2 && Math.abs(cx)<=0.68) return true; // side spokes
    if(Math.abs(cx)<=0.11 && cy>=0.2 && cy<=0.68) return true; // bottom spoke
    return false;
  };
  const rand=(a,b)=>a+Math.random()*(b-a);
  const frag=document.createDocumentFragment();
  for(let gy=0;gy<N;gy++) for(let gx=0;gx<N;gx++){
    const cx=(gx+0.5)/N*2-1, cy=(gy+0.5)/N*2-1;
    if(!inShape(cx,cy) || Math.random()<0.08) continue;
    const e=1.6/N;
    const edge=!(inShape(cx+e,cy)&&inShape(cx-e,cy)&&inShape(cx,cy+e)&&inShape(cx,cy-e));
    const px=document.createElement("i");
    const accent=Math.random()<0.14;
    px.className=(edge?"edge":"")+(accent?" acc":"");
    px.style.cssText="left:"+(gx*cell)+"%;top:"+(gy*cell)+"%;width:"+(cell*0.86)+"%;height:"+(cell*0.86)+"%;"+
      "--c:rgba(255,255,255,"+(accent?rand(0.2,0.34):rand(0.12,0.3)).toFixed(2)+");"+
      "--o:"+rand(0.5,1).toFixed(2)+";--d:"+rand(3,7).toFixed(1)+"s;--dl:"+rand(-7,0).toFixed(1)+"s;"+
      "--jx:"+rand(-3,3).toFixed(1)+"px;--jy:"+rand(-3,3).toFixed(1)+"px";
    frag.appendChild(px);
  }
  host.appendChild(frag);
}
initWaitlist();
window.go=go; window.goStep=goStep; window.onMake=onMake; window.submitWaitlist=submitWaitlist; window.openWaitlistModal=openWaitlistModal; window.closeWaitlistModal=closeWaitlistModal;
window.setSel=setSel; window.renderReview=renderReview; window.startCheckout=startCheckout; window.saveDraft=saveDraft; window.S=S;
init();
